import React, { PropsWithChildren } from 'react'

const StepTitle = ( { children }:Props ) => {


  return ( 
    <div className="text-xl font-medium font-fire-sans" > 
      { children }
    </div>
  )
}

interface Props extends PropsWithChildren<any>{}

export { StepTitle }
